import i18n from "i18next";

// Side-effect-FREIES Modul (TES-1653): nutzt die i18next-Singleton-Instanz, ruft aber KEIN
// i18n.init() (das lebt in ./index.ts). Dadurch koennen Consumer wie useLanguagePreference den
// Lazy-Loader importieren, ohne den i18n-Init (der initReactI18next braucht) in ihren Modulgraph
// zu ziehen — sonst brechen Tests, die react-i18next teil-mocken.
//
// Nur die Default-/Fallback-Sprache `de` ist eager gebundlet (siehe ./index.ts). en/ja (~489KB)
// werden hier on-demand als eigene Chunks nachgeladen.
const localeLoaders: Record<string, () => Promise<{ default: Record<string, unknown> }>> = {
  en: () => import("./locales/en.json"),
  ja: () => import("./locales/ja.json"),
};

// Bewusst kompakter Guarded-Async-Loader (Guard + Loader-Lookup + try/catch + Re-emit); gut
// lesbar, aber knapp ueber der fallow-Heuristik — daher die Suppression direkt darunter.
// fallow-ignore-next-line complexity
export async function ensureLanguageLoaded(lng: string | undefined): Promise<void> {
  const base = (lng ?? "").split("-")[0];
  if (!base || base === "de" || i18n.hasResourceBundle(base, "translation")) return;
  const loader = localeLoaders[base];
  if (!loader) return;
  try {
    const mod = await loader();
    i18n.addResourceBundle(base, "translation", mod.default, true, true);
    // re-emit, damit react-i18next nach dem Nachladen mit der Ziel-Sprache neu rendert
    if (i18n.language?.split("-")[0] === base) {
      i18n.changeLanguage(i18n.language);
    }
  } catch {
    // Locale-Chunk nicht ladbar (z.B. 404 eines gehashten Chunks in einem alten Tab nach Deploy,
    // oder Netzwerkfehler) — bewusst verschlucken: react-i18next bleibt auf dem de-Fallback. Kein
    // Throw/unhandledrejection (sonst meldet die Sentry-Browser-SDK einen falschen Error). (TES-1653)
  }
}
